
import React, { useState } from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

const GooglePlacesAutocomplete = ({ onSelect, placeholder = "Buscar dirección en Bogotá..." }) => {
    const [address, setAddress] = useState('');

    const handleSelect = async (value) => {
        let searchValue = value;
        // Robustness: Automatically add context if user didn't type it
        if (!searchValue.toLowerCase().includes('bogotá') && !searchValue.toLowerCase().includes('bogota')) {
            searchValue += ', Bogotá, Colombia';
        }
        setAddress(value);
        try {
            const results = await geocodeByAddress(searchValue);
            const latLng = await getLatLng(results[0]);

            if (onSelect) {
                onSelect({
                    // [FIX] Use 'value' (user selection) instead of 'formatted_address' 
                    // to preserve Place Names (e.g. "CC Milenio") which Google's geocoder often strips.
                    address: value,
                    coordinates: [latLng.lng, latLng.lat], // Mapbox uses [lng, lat], Google uses {lat, lng} - unifying to Array
                    context: results[0].address_components,
                    full_feature: results[0]
                });
            }
        } catch (error) {
            console.error('Error selecting address', error);
        }
    };

    const searchOptions = {
        componentRestrictions: { country: 'co' },
        // types: ['address'] <- Removed to allow 'establishment' (businesses, POIs)
    };

    // Safely add bounds bias if Google Maps is loaded
    if (window.google && window.google.maps) {
        // Bogotá Bounds (South-West to North-East)
        const southWest = new window.google.maps.LatLng(4.4711, -74.2235);
        const northEast = new window.google.maps.LatLng(4.8368, -73.9877);
        searchOptions.bounds = new window.google.maps.LatLngBounds(southWest, northEast);
        searchOptions.strictBounds = true; // Prioritize results strictly within Bogotá
    }

    return (
        <div className="google-places-wrapper" style={{ position: 'relative', width: '100%', zIndex: 1000 }}>
            {/* Helper Script Loader is usually in index.html, but we can assume it's loaded if we are strictly replacing */}
            {/* Actually, react-places-autocomplete needs the Google Maps script loaded in standard way */}
            <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelect}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div className="relative">
                        <input
                            {...getInputProps({
                                placeholder: placeholder,
                                className: 'w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900',
                            })}
                        />
                        <div className="autocomplete-dropdown-container absolute w-full bg-white shadow-lg rounded-b-lg border-t-0 border-gray-200 overflow-hidden z-50">
                            {loading && <div className="p-2 text-sm text-gray-500">Cargando...</div>}
                            {suggestions.map((suggestion) => {
                                const className = suggestion.active
                                    ? 'suggestion-item--active bg-blue-50 cursor-pointer p-3 border-b border-gray-100'
                                    : 'suggestion-item bg-white cursor-pointer p-3 border-b border-gray-100 hover:bg-gray-50';

                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                        })}
                                        key={suggestion.placeId}
                                    >
                                        <span className="font-medium text-gray-800 block">{suggestion.formattedSuggestion.mainText}</span>
                                        <span className="text-sm text-gray-500 block">{suggestion.formattedSuggestion.secondaryText}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </div>
    );
};

export default GooglePlacesAutocomplete;
